import { debounce } from '../utils/debounce';
import { breakpoints } from '../utils/breakpoints';

const handleResponsiveVideo = () => {
  const selectors = {
    section: '.js-responsive-video',
  };
  const videos = [...document.querySelectorAll(selectors.section)];

  if (videos.length === 0) return;

  const checkWindowWidth = () => {
    return window.innerWidth < breakpoints.mobile ? 'sm' : 'xl';
  };

  const initVideosSrc = () => {
    videos?.forEach((video) => {
      const deviceSize = checkWindowWidth();
      const sources = [...video.querySelectorAll('source')];
      sources.forEach((source) => {
        if (deviceSize === 'sm') {
          source.setAttribute('src', source.dataset.mobileVid);
        } else {
          source.setAttribute('src', source.dataset.desktopVid);
        }
      });

      video.load();
    });
  };
  let prevHeight = window.innerHeight;
  let prevWidth = window.innerWidth;

  initVideosSrc();
  window.addEventListener(
    'resize',
    debounce(() => {
      if (
        Math.abs(prevHeight - window.innerHeight) < 100 &&
        prevWidth === window.innerWidth
      )
        return;

      initVideosSrc();
      prevWidth = window.innerWidth;
      prevHeight = window.innerHeight;
    }, 300)
  );
};

export default handleResponsiveVideo;
